// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `app-gallery-thumbnail .container {
  position: relative;
  border-radius: 10px;
}
app-gallery-thumbnail .container.locked img {
  opacity: 0.7;
}
app-gallery-thumbnail .container.unlockable {
  cursor: pointer;
}
app-gallery-thumbnail .container.unlockable img {
  opacity: 0.7;
}
app-gallery-thumbnail .container.available {
  cursor: pointer;
}
app-gallery-thumbnail .container.available img {
  opacity: 0.85;
}
app-gallery-thumbnail .container.selected img {
  opacity: 1;
}
app-gallery-thumbnail .container img {
  border-radius: 10px;
  background: white;
  height: 268px;
  width: 268px;
}
app-gallery-thumbnail .container > .locked {
  display: flex;
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  justify-content: center;
  align-items: center;
}
app-gallery-thumbnail .container > .locked > .btn {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 58px;
  width: 58px;
  border-radius: 50%;
  box-shadow: 0px 0px 10px rgba(255, 255, 255, 0.5);
  flex-flow: column;
}
app-gallery-thumbnail .container > .locked > .btn.locked-icon {
  background: #DADADA;
  color: #fff;
}
app-gallery-thumbnail .container > .locked > .btn.locked-icon mat-icon path {
  fill: #fff;
}
app-gallery-thumbnail .container > .locked > .btn.unlock {
  background: rgba(36, 183, 199, 0.9);
  color: #fff;
  font-weight: 600;
}
app-gallery-thumbnail .container > .locked > .btn.unlock mat-icon {
  min-width: unset;
  min-height: unset;
  width: 18px;
  height: 18px;
}
app-gallery-thumbnail .container > .locked > .btn.unlock mat-icon svg {
  width: 18px;
  height: 18px;
}
app-gallery-thumbnail .container > .locked > .btn.unlock mat-icon svg path {
  fill: #fff;
}
app-gallery-thumbnail .container > .unlocked {
  display: flex;
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  align-items: flex-end;
  justify-content: flex-end;
}
app-gallery-thumbnail .container > .unlocked > .avatar-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 37px;
  width: 37px;
  border-radius: 50%;
  box-shadow: 0px 0px 10px rgba(255, 255, 255, 0.5);
  background: rgba(255, 255, 255, 0.5);
  border: 2px solid #EC6602;
  position: relative;
  margin-right: 8px;
  margin-bottom: 8px;
}
app-gallery-thumbnail .container > .unlocked > .avatar-icon path {
  fill: rgba(236, 102, 2, 0.8);
}
app-gallery-thumbnail .container > .unlocked > .avatar-icon > .avatar-default {
  display: none;
}
app-gallery-thumbnail .container > .unlocked > .avatar-icon.selected {
  background: rgba(236, 102, 2, 0.8);
  border: none;
}
app-gallery-thumbnail .container > .unlocked > .avatar-icon.selected path {
  fill: #fff;
}
app-gallery-thumbnail .container > .unlocked > .avatar-icon.selected > .avatar-default {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: -6px;
  right: -6px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.9);
  width: 18px;
  height: 18px;
}
app-gallery-thumbnail .container > .unlocked > .avatar-icon.selected > .avatar-default mat-icon {
  min-width: unset;
  min-height: unset;
  width: 14px;
  height: 14px;
  font-size: 14px;
  line-height: 14px;
}
app-gallery-thumbnail .container > .unlocked > .avatar-icon.selected > .avatar-default mat-icon path {
  fill: #81B52B;
}
app-gallery-thumbnail .container > .unlocked > .avatar-icon.locked-icon {
  background: #DADADA;
}
app-gallery-thumbnail .container > .unlocked > .avatar-icon.unlock {
  background: rgba(36, 183, 199, 0.9);
  color: #fff;
}`, "",{"version":3,"sources":["webpack://./src/app/@modules/gamification/core/gallery-thumbnail/gallery-thumbnail.component.scss"],"names":[],"mappings":"AACI;EACI,kBAAA;EACA,mBAAA;AAAR;AAIY;EACI,YAAA;AAFhB;AAOQ;EACI,eAAA;AALZ;AAOY;EACI,YAAA;AALhB;AASQ;EACI,eAAA;AAPZ;AASY;EACI,aAAA;AAPhB;AAYY;EACI,UAAA;AAVhB;AAgBQ;EACI,mBAAA;EACA,iBAAA;EACA,aAAA;EACA,YAAA;AAdZ;AAiBQ;EACI,aAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,MAAA;EACA,OAAA;EAEA,uBAAA;EACA,mBAAA;AAhBZ;AAkBY;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,iDAAA;EACA,iBAAA;AAhBhB;AAkBgB;EACI,mBAAA;EACA,WAAA;AAhBpB;AAmBwB;EACI,UAAA;AAjB5B;AAsBgB;EACI,mCAAA;EACA,WAAA;EACA,gBAAA;AApBpB;AAsBoB;EACI,gBAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;AApBxB;AAsBwB;EACI,WAAA;EACA,YAAA;AApB5B;AAsB4B;EACI,UAAA;AApBhC;AA6BQ;EACI,aAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,MAAA;EACA,OAAA;EACA,qBAAA;EACA,yBAAA;AA3BZ;AA6BY;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,iDAAA;EACA,oCAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;AA3BhB;AA8BgB;EACI,4BAAA;AA5BpB;AA+BgB;EACI,aAAA;AA7BpB;AAgCgB;EACI,kCAAA;EACA,YAAA;AA9BpB;AAgCoB;EACI,UAAA;AA9BxB;AAiCoB;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;EACA,oCAAA;EACA,WAAA;EACA,YAAA;AA/BxB;AAiCwB;EACI,gBAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;AA/B5B;AAiC4B;EACI,aAAA;AA/BhC;AAqCgB;EACI,mBAAA;AAnCpB;AAsCgB;EACI,mCAAA;EACA,WAAA;AApCpB","sourcesContent":["app-gallery-thumbnail {\r\n    .container {\r\n        position: relative;\r\n        border-radius: 10px;\r\n\r\n\r\n        &.locked {\r\n            img {\r\n                opacity: 0.70;\r\n            }\r\n        }\r\n\r\n\r\n        &.unlockable {\r\n            cursor: pointer;\r\n\r\n            img {\r\n                opacity: 0.70;\r\n            }\r\n        }\r\n\r\n        &.available {\r\n            cursor: pointer;\r\n\r\n            img {\r\n                opacity: 0.85;\r\n            }\r\n        }\r\n\r\n        &.selected {\r\n            img {\r\n                opacity: 1;\r\n            }\r\n        }\r\n\r\n\r\n\r\n        img {\r\n            border-radius: 10px;\r\n            background: white;\r\n            height: 268px;\r\n            width: 268px;\r\n        }\r\n\r\n        >.locked {\r\n            display: flex;\r\n            position: absolute;\r\n            height: 100%;\r\n            width: 100%;\r\n            top: 0;\r\n            left: 0;\r\n\r\n            justify-content: center;\r\n            align-items: center;\r\n\r\n            >.btn {\r\n                display: flex;\r\n                justify-content: center;\r\n                align-items: center;\r\n                height: 58px;\r\n                width: 58px;\r\n                border-radius: 50%;\r\n                box-shadow: 0px 0px 10px rgba(255, 255, 255, 0.5);\r\n                flex-flow: column;\r\n\r\n                &.locked-icon {\r\n                    background: #DADADA;\r\n                    color: #fff;\r\n\r\n                    mat-icon {\r\n                        path {\r\n                            fill: #fff;\r\n                        }\r\n                    }\r\n                }\r\n\r\n                &.unlock {\r\n                    background: rgba(36, 183, 199, 0.9);\r\n                    color: #fff;\r\n                    font-weight: 600;\r\n\r\n                    mat-icon {\r\n                        min-width: unset;\r\n                        min-height: unset;\r\n                        width: 18px;\r\n                        height: 18px;\r\n\r\n                        svg {\r\n                            width: 18px;\r\n                            height: 18px;\r\n\r\n                            path {\r\n                                fill: #fff;\r\n                            }\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n\r\n        }\r\n\r\n        >.unlocked {\r\n            display: flex;\r\n            position: absolute;\r\n            height: 100%;\r\n            width: 100%;\r\n            top: 0;\r\n            left: 0;\r\n            align-items: flex-end;\r\n            justify-content: flex-end;\r\n\r\n            >.avatar-icon {\r\n                display: flex;\r\n                justify-content: center;\r\n                align-items: center;\r\n                height: 37px;\r\n                width: 37px;\r\n                border-radius: 50%;\r\n                box-shadow: 0px 0px 10px rgba(255, 255, 255, 0.5);\r\n                background: rgba(255, 255, 255, 0.5);\r\n                border: 2px solid #EC6602;\r\n                position: relative;\r\n                margin-right: 8px;\r\n                margin-bottom: 8px;\r\n\r\n\r\n                path {\r\n                    fill: rgba(236, 102, 2, 0.8);\r\n                }\r\n\r\n                >.avatar-default {\r\n                    display: none;\r\n                }\r\n\r\n                &.selected {\r\n                    background: rgba(236, 102, 2, 0.8);\r\n                    border: none;\r\n\r\n                    path {\r\n                        fill: #fff;\r\n                    }\r\n\r\n                    >.avatar-default {\r\n                        display: flex;\r\n                        align-items: center;\r\n                        justify-content: center;\r\n                        position: absolute;\r\n                        top: -6px;\r\n                        right: -6px;\r\n                        border-radius: 50%;\r\n                        background: rgba(255, 255, 255, 0.9);\r\n                        width: 18px;\r\n                        height: 18px;\r\n\r\n                        mat-icon {\r\n                            min-width: unset;\r\n                            min-height: unset;\r\n                            width: 14px;\r\n                            height: 14px;\r\n                            font-size: 14px;\r\n                            line-height: 14px;\r\n\r\n                            path {\r\n                                fill: #81B52B;\r\n                            }\r\n                        }\r\n                    }\r\n                }\r\n\r\n                &.locked-icon {\r\n                    background: #DADADA;\r\n                }\r\n\r\n                &.unlock {\r\n                    background: rgba(36, 183, 199, 0.9);\r\n                    color: #fff;\r\n                }\r\n            }\r\n\r\n        }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
